<template>
  <component
    :is="type"
    :class="baseClassNames"
    ref="ref"
    :data-text="text"
    v-html="genText"
  />
</template>

<script>
export default {
  name: "Heading",
  props: {
    className: String,
    glow: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "h3",
    },
    shuffle: {
      type: Boolean,
      default: false,
    },
    spaced: {
      type: Boolean,
      default: false,
    },
    accent: {
      type: Boolean,
      default: false,
    },
    loop: {
      type: Boolean,
      default: false,
    },
    shuffleDuration: {
      type: Number,
      default: 200, // ms
    },
    text: {
      type: String,
    },
    viewable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    baseClassNames() {
      const classNames = [];

      this.glow && classNames.push("glow");
      this.shuffle && classNames.push("shuffle");
      this.loop && classNames.push("loop");
      this.spaced && classNames.push("spaced");
      this.accent && classNames.push("section-accent");
      this.className && classNames.push(this.className);

      return classNames;
    },
    isWindows() {
      return navigator.userAgent.includes("Win");
    },
  },
  data() {
    return {
      genText: this.text,
    };
  },
  watch: {
    viewable: function () {
      if (this.viewable) {
        this.transitionShuffle();
      }
    },
  },
  methods: {
    shuffleText: function () {
      //This one will take one random letter in th text and replace it with an Mendes character
      //This function will also reset the string, so only one character is changing at a time.
      const text = this.text;
      let splitText = text.split("");
      const num = Math.floor(Math.random() * splitText.length);
      let characters;
      if (this.isWindows) {
        characters = [
          "a",
          "b",
          "c",
          "d",
          "e",
          "f",
          "g",
          "h",
          "i",
          "j",
          "k",
          "l",
          "m",
          "n",
          "o",
          "q",
          "r",
          "s",
          "t",
          "u",
          "v",
          "w",
          "x",
          "y",
          "z",
        ];
      } else {
        // characters = ["𞢥", "𞠐", "𞠘", "𞠟", "𞡉"];
        characters = [
          "\u{1E8A5}",
          "\u{1E810}",
          "\u{1E818}",
          "\u{1E81F}",
          "\u{1E849}",
        ];
      }

      splitText[num] =
        splitText[num] == " "
          ? " "
          : characters[Math.floor(Math.random() * characters.length)];

      return splitText.join("");
    },

    shuffleIteration: function () {
      return setInterval(() => {
        this.genText = this.shuffleText();
      }, 100);
    },
    shuffleLoop: function () {
      setInterval(() => {
        //This loop will run every 6 seconds and make the text glitch out periodically.

        //Immediately start glitch
        const glitch = this.shuffleIteration();

        setTimeout(() => {
          clearInterval(glitch);
          this.genText = this.text; // There is a chance the clearInterval cuts off the glitch before it can reset. Manual reset.
        }, 1000);
      }, 6000);
    },

    transitionShuffle: function () {
      //Initial shuffle for 1.5 seconds. Then start the loop.
      const glitch = this.shuffleIteration();
      return setTimeout(() => {
        clearInterval(glitch);
        this.genText = this.text; // There is a chance the clearInterval cuts off the glitch before it can reset. Manual reset.

        if (this.loop) {
          this.shuffleLoop();
        }
      }, 1500);
    },
  },
  mounted() {
    if (this.viewable && this.shuffle) {
      this.transitionShuffle();
    }
  },
};
</script>

<style></style>
